import { render, staticRenderFns } from "./MailTemplatesPanel.vue?vue&type=template&id=181a1ffc&scoped=true"
import script from "./MailTemplatesPanel.vue?vue&type=script&lang=js"
export * from "./MailTemplatesPanel.vue?vue&type=script&lang=js"
import style0 from "./MailTemplatesPanel.vue?vue&type=style&index=0&id=181a1ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181a1ffc",
  null
  
)

export default component.exports